import { Subject } from 'rxjs';
import { MessageDescriptor } from 'react-intl';
import { ConfigOptions } from 'antd/es/message/interface';
import { Category, Image } from 'utils/apiClient/services/inventory/types';
import { SettingsHeroImage } from 'Settings/types';

export interface MsgI<Data = any> {
  topic: string;
  data: Data;
}

type UIMessageTopic = 'success' | 'error' | 'info' | 'warning' | 'loading';
type MessageOptions = ConfigOptions & { values?: Record<string, any> };
export interface UIMessageI {
  topic: UIMessageTopic;
  data: {
    message: MessageDescriptor;
    messageOptions: MessageOptions;
  };
}

export const UIMessage = new Subject<UIMessageI>();
export const publishUIMessage = (
  level: UIMessageTopic,
  message: MessageDescriptor,
  messageOptions: MessageOptions = {}
) => UIMessage.next({ topic: level, data: { message, messageOptions } });

export const publishSuccessUIMsg = (
  message: MessageDescriptor,
  messageOptions: MessageOptions = {}
) => UIMessage.next({ topic: 'success', data: { message, messageOptions } });

export const publishErrorUIMsg = (
  message: MessageDescriptor,
  messageOptions: MessageOptions = {}
) => UIMessage.next({ topic: 'error', data: { message, messageOptions } });

export const NewVersionNotification = new Subject<void>();

export const Notification = new Subject<MsgI>();

export const push = (topic: string, data: any = undefined) =>
  Notification.next({ topic, data });

export const RECEIVE_ORDER_ITEMS_SUCCESS_TOPIC =
  'RECEIVE_ORDER_ITEMS_SUCCESS_TOPIC';
export const RECEIVE_ORDER_ITEMS_FAIL_TOPIC = 'RECEIVE_ORDER_ITEMS_FAIL_TOPIC';

export const PRODUCTS_BATCH_ACTION_PROCESSING =
  'PRODUCTS_BATCH_ACTION_PROCESSING';

export const CATEGORY_CREATED_FOR_PRODUCT = 'CATEGORY_CREATED_FOR_PRODUCT';

export const PRODUCTS_BATCH_ACTION_FINISHED = 'PRODUCTS_BATCH_ACTION_FINISHED';

export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAIL = 'UPLOAD_IMAGE_FAIL';
export const DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS';
export const DELETE_IMAGE_FAIL = 'DELETE_IMAGE_FAIL';

export function pushReceiveOrderItemsSuccess(data?: any) {
  push(RECEIVE_ORDER_ITEMS_SUCCESS_TOPIC, data);
}

export function pushReceiveOrderItemsFail(data?: any) {
  push(RECEIVE_ORDER_ITEMS_FAIL_TOPIC, data);
}

export function pushProductsBatchActionProcessing(data?: any) {
  push(PRODUCTS_BATCH_ACTION_PROCESSING, data);
}

export function pushProductsBatchActionFinished(data?: any) {
  push(PRODUCTS_BATCH_ACTION_FINISHED, data);
}

export function pushCategoryCreatedForProduct(data: Category) {
  push(CATEGORY_CREATED_FOR_PRODUCT, data);
}

export function pushUploadImageSuccess(data: Image | SettingsHeroImage) {
  push(UPLOAD_IMAGE_SUCCESS, data);
}

export function pushUploadImageFail() {
  push(UPLOAD_IMAGE_FAIL, null);
}

export function pushDeleteImageSuccess(data: any) {
  push(DELETE_IMAGE_SUCCESS, data);
}

export function pushDeleteImageFail(data: any) {
  push(DELETE_IMAGE_FAIL, data);
}
